
import { defineComponent, PropType } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

const __default__ = defineComponent({
  mixins: [CookiesCoreMixinVue],
  props: {
    Items: { type: Object as PropType<NavItem[]> },
    IconsSheet: { default: '' }
  },
  methods: {
    LogOut () {
      this.OpenDialog('Security_Logout_Dialog', this.Translate('Log Out'), {}) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
    },
    ChangeBranch () {
      this.OpenDialog('Inventory_Branch_Selector', 'Select Branch', {})
    },
    ChangeWarehouse () {
      this.OpenDialog('Inventory_Warehouse_Selector', 'Select Branch', {})
    },
    LogIN () {
      this.$store.state.AutoSignIn = false
      this.$store.state.Accessable = false
    },
    ChangeLanguage () {
      this.OpenDialog('ChangeLanguage', this.Translate('Select Language'), {})
    }
  },
  computed: {
    CurrentPage () {
      return this.$route.matched[0].name
    },
    Icons () {
      return this.IconsSheet === '' ? require('@/assets/icons/ThemeIcons.svg') : this.IconsSheet
    }
  }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "1b2ab800": (_ctx.Theme.BG3),
  "021661dc": (_ctx.Theme.BackBlur),
  "42a33108": (_ctx.Theme.UserColors.main_50),
  "1001e063": (_ctx.Theme.UserColors.fourth_25),
  "e1b7c1d8": (_ctx.Theme.Shade3),
  "1b2ab7ff": (_ctx.Theme.BG2),
  "4d1f66b5": (_ctx.Theme.BG2Fixed),
  "1b2ab803": (_ctx.Theme.BG6),
  "1001e0bb": (_ctx.Theme.UserColors.fourth_50)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__